var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:"form",staticClass:"report-procurement",staticStyle:{"padding":"20px"},attrs:{"model":_vm.form}},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"招采总览"}},[_c('platform')],1),_c('el-tab-pane',{attrs:{"label":"效益分析"}},[_c('procurement-overview')],1),_c('el-tab-pane',{attrs:{"label":"风险分析"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }